<script>
import { getAllExistingWorkoutLogDates } from '@/services/WorkoutServices';

export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      loading: true,
      //
      allWorkoutsFromDB: {},
      workoutExistsInCookies: false,
    };
  },
  computed: {
    buttonText() {
      return this.workoutExistsInCookies ? 'Continue Your Workout' : 'Start a New Workout';
    },
    workouts() {
      const sortedWorkouts = Object.keys(this.allWorkoutsFromDB);
      sortedWorkouts.sort((b, a) => a.localeCompare(b));

      return sortedWorkouts.map(original => {
        const hyphenCount = (original.match(/-/g) || []).length;

        if (hyphenCount === 2) {
          // Plain date
          return {
            display: original,
            value: original
          };
        }
        else if (hyphenCount === 3) {
          // Has the -N suffix
          const baseDate = original.substring(0, original.lastIndexOf('-'));
          const suffix = original.substring(original.lastIndexOf('-') + 1);

          return {
            display: `${baseDate} (${suffix})`,
            value: original
          };
        }

        // Fallback in case something weird slips in
        return {
          display: original,
          value: original
        };
      });
    },
  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    this.allWorkoutsFromDB = await getAllExistingWorkoutLogDates(this.uId, this.token);
    this.workoutExistsInCookies = this.$cookies.isKey('workoutDraft');

    this.loading = false;
    // console.log('*** sorted workouts ***', this.workouts);
    // console.log('*** workout from cookie ***', this.workoutExistsInCookies);

  },
}
</script>

<template>
<div id="page-workouts-all">

  <div id="page-header" class="pa-4 mb-16 d-flex flex-column align-center">
    <h1>All Workout Logs</h1>
    <router-link to="/workout">
      <v-btn color="green-lighten-1"
             density="comfortable"
             class="mt-8 text-capitalize"
      >{{ buttonText }}</v-btn>
    </router-link>
  </div> <!-- end #page-header -->


  <!-- list of all workouts -->
  <div v-if="loading" class="d-flex justify-center align-center">
    <v-progress-circular :width="8"
                         color="yellow-darken-2"
                         indeterminate
    ></v-progress-circular>
  </div>
  <div v-else class="d-flex flex-column align-center">

    <h2 class="">Past Workout Logs</h2>
    <p class="text-body-2 mb-7"><i>newest to oldest</i></p>

    <ol v-if="workouts.length">
      <li v-for="d in workouts" :key="d.value" class="mb-6">
        <a :href="`/workout/${d.value}`" class="ps-3 text-blue-darken-3 text-decoration-none">
          {{ d.display }}
        </a>
      </li>
    </ol>
    <p v-else class="mt-4 font-italic text-center">
      No Workouts
      <br />
      <br />
      <br />
      WE GO JIM!
    </p>
  </div>


</div>
</template>

<style scoped lang="scss">
#page-workouts-all {
  max-width: 700px;
  margin: 0 auto;
}
</style>
